module.exports = __webpack_public_path__ + "img/home_server_3.0958f493.png";